import Text from 'src/components/Text';
import { WHITE, SECONDARY_GRAY_80 } from 'src/global/theme/colors';
import classNames from 'classnames';

import { styles } from './styles';

interface Props {
  pageNumber: number;
  active: boolean;
  handlePagination: (pageNumber: number) => void;
}

const PaginationItem = ({ pageNumber, active, handlePagination }: Readonly<Props>) => {
  const { classes } = styles();
  return (
    <button
      type="button"
      data-testid={`${pageNumber}-button-pagination`}
      className={classNames(classes.numberItem, {
        [classes.active]: active
      })}
      aria-current={active ? 'page' : undefined}
      onClick={() => handlePagination(pageNumber)}>
      <Text color={active ? WHITE : SECONDARY_GRAY_80} variant={active ? 'H4-Bold' : 'Callout-Medium'}>
        {pageNumber}
      </Text>
    </button>
  );
};

export default PaginationItem;
